export default "__VITE_ASSET__BPtayBAy__"